// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__DrD--","brandName":"Logo_brandName__Gi8R3"};